import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { StyleColor } from '../../../../utils/styles-constants';

interface StyledSelectProps {
	isFontSelect?: boolean;
}

const StyledSelect = styled('div')`
	display: flex;
	align-items: center;

	&:not(:last-child) {
		margin-bottom: 20px;
	}

	${(props: StyledSelectProps) => (
		props.isFontSelect && `height: 18px;`
	)}
`;

const Label = styled(Translate)`
	margin-right: auto;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 18px;
	color: ${StyleColor.Black};
`;

const ButtonValue = styled('button')`
	margin-left: 10px;
	padding: 0;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 18px;
	color: ${StyleColor.Blue600};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	background-color: transparent;
	cursor: pointer;
`;

const ButtonIcon = styled('button')`
	height: 13px;
	padding: 0;
	border: 0;
	outline: 0;
	background-color: transparent;
	cursor: pointer;

	svg {
		width: 12px;
		height: 13px;
		margin-left: 14px;
		fill: ${StyleColor.Grey450};
		transform: rotate(180deg);
	}
`;

const Color = styled('div')`
	box-sizing: border-box;
	width: 115px;
	height: 30px;
	border: 1px solid ${StyleColor.Black};
	border-radius: 6px;
`;

const Options = styled('div')`
	position: absolute;
	z-index: 2;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 15px 0;
	border-radius: 13px;
	background-color: ${StyleColor.Grey50};
`;

const OptionsHeader = styled('div')`
	position: relative;
	padding: 0 85px;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 700;
	font-size: 13px;
	line-height: 16px;
	color: ${StyleColor.Black};
	text-align: center;
`;

const OptionsList = styled('ul')`
	height: calc(100% - 35px);
	margin: 0;
	margin-top: 20px;
	padding: 0;
	list-style-type: none;
	overflow-y: auto;
`;

const ButtonOption = styled('button')`
	position: relative;
	height: 38px;
	width: 100%;
	padding: 0 20px 0 40px;
	border: 0;
	outline: 0;
	background-color: transparent;
	font-size: 12px;
	line-height: 38px;
	color: ${StyleColor.Black};
	text-align: left;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;

	&:hover {
		background-color: ${StyleColor.Grey100};
	}

	svg {
		position: absolute;
		top: 15px;
		left: 20px;
		width: 10px;
		height: 8px;
		color: ${StyleColor.Blue300};
	}
`;

const ButtonBack = styled('button')`
	position: absolute;
	top: 0;
	left: 15px;
	height: 16px;
	padding: 0;
	padding-left: 20px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 700;
	font-size: 13px;
	line-height: 16px;
	color: ${StyleColor.Blue600};
	background-color: transparent;
	cursor: pointer;

	svg {
		position: absolute;
		top: -3px;
		left: 0;
		width: 16px;
		height: 20px;
		fill: currentColor;
	}
`;


export {
	StyledSelect,
	Label,
	ButtonValue,
	ButtonIcon,
	Color,
	Options,
	OptionsHeader,
	OptionsList,
	ButtonOption,
	ButtonBack,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/Select/styles.ts